<template>
  <div class="context-menu" :class="{'hide': !menuVisible}">
    <div :class="{'opened' : showContextOptions}" class="context-menu-container" :style="'top:' + top + 'px;' + leftRight + ':'+(leftRight === 'right' ? 25 : 38 )+'px;'">
      <div @click="reply" class="context-menu-container_item">
        <span>{{trans('reply')}}</span>
        <span><img src="/main/img/icons/reply_new.svg"></span>
      </div>
      <div v-if="(msg.msg_type === 'image' && msg.user_from === currentUserId) || msg.msg_type === 'text'" class="context-menu-container_item" @click="copy">
        <span>{{trans('copy')}}</span>
        <span><img src="/main/img/icons/copy.svg"></span>
      </div>
      <div class="context-menu-container_item delete" v-if="msg.user_from === currentUserId || (event && event.type === 'club' && event.user_id === currentUserId)" @click="deleteMessage">
        <span>{{trans('delete_for_all')}}</span>
        <span><img src="/main/img/icons/delete.svg"></span>
      </div>
    </div>
    <div @click="hideMenu" class="context-menu-blur" :class="{'show': blurVisible}">

    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import chatModule from '@chat/module/store/type'
import auth from '@general/lib/auth';
import * as CopyImageClipboard from "copy-image-clipboard";

export default {
    props: ['chatMode', 'userId', 'eventId', 'event'],

    mixins: [
      require('@general/lib/mixin').default
    ],
    computed: {
        ...mapGetters({
        }),
        height (){
          let height = 162;
          if((this.msg.msg_type !== 'image' || this.msg.user_from !== auth.getUserId()) && this.msg.msg_type !== 'text'){
            //remove copy button
            height -= 54;
          }
          if(this.msg.user_from !== this.currentUserId && !(this.event && this.event.type === 'club' && this.event.user_id === this.currentUserId)){
            //remove delete button
            height -= 54;
          }
          return  height;
        },
        currentUserId (){
          return auth.getUserId()
        },
    },
    methods: {
        ...mapActions({
        }),
      changeTop(top){
          this.top = top;
      },
      showMenu(msg,emoji_panel,index){
        this.msg = msg;
        let self = this;
        this.menuVisible = true;
        $('#msg-' + msg.id).find('.timeline').css('opacity',0);
        let timeline = $('#msg-' + msg.id).find('.timeline');
        let timeline_height = timeline.length ? timeline.height() + 30 : 0; //30 - margin
        this.leftRight = msg.user_from !== auth.getUserId() ? 'left' : 'right';
        this.top = document.getElementById("msg-" + msg.id).getBoundingClientRect().top
            - document.getElementsByClassName("conversation-screen")[0].getBoundingClientRect().top + $('#msg-' + msg.id).height();
        let msg_top_changed = false;
        setTimeout(function (){
          self.blurVisible = true;
        },20)
        let footer_textarea = document.getElementsByClassName("conversation-screen")[0].getBoundingClientRect().bottom
            - document.getElementsByClassName("conversation-screen")[0].getBoundingClientRect().top - 10; //10px from bottom screen

        //context menu must be above screen bottom
        if(this.top + this.height > footer_textarea){
          msg_top_changed= true;
          $('#msg-' + msg.id).css('top','-'+(this.top + this.height - footer_textarea) + 'px');
          this.top -= this.top + this.height - footer_textarea;
        }

        //check if message above the chat message
        let msg_top = $('#msg-' + msg.id)[0].getBoundingClientRect().top - document.getElementsByClassName("conversation-screen")[0].getBoundingClientRect().top + timeline_height;
        let chat_top = 10; //10p from conversation top
        if(msg_top < chat_top && this.msg.channel === 'group'){
          //for user and vent chats this will be fixed in emoji component
          //msg above chat top
          //we need to check if we will put message down, context menu must be above footer
          let future_message_and_context_top = (chat_top) + $('#msg-' + msg.id).outerHeight() - timeline_height + this.height;
          if(future_message_and_context_top < footer_textarea){
            msg_top_changed = true;
            $('#msg-' + msg.id).css('top',(chat_top - msg_top) + 'px');
            this.top = (chat_top) + $('#msg-' + msg.id).outerHeight() - timeline_height;
          }
        }
        let showMenuAndEmoji = function(){
          if(self.msg.channel !== 'group'){
            let conversation_key = self.chatMode === 'event' ? self.eventId +'-'+ self.userId : self.userId;
            emoji_panel.showModal(msg,index,conversation_key, self)
          }
          self.showContextOptions = true;

          document.getElementById('msg-' + msg.id).removeEventListener('transitionend',showMenuAndEmoji);
        };
        if(msg_top_changed){
          document.getElementById('msg-' + msg.id).addEventListener('transitionend', showMenuAndEmoji, false );
        }else{
          setTimeout(function () {
            showMenuAndEmoji();
          },20)
        }

      },
      async copy(){
        if(this.msg.msg_type === 'text'){
          navigator.clipboard.writeText(this.msg.message).then(function() {
            console.log('Async: Copying to clipboard was successful!');
          }, function(err) {
            console.error('Async: Could not copy text: ', err);
          });
        }else if(this.msg.msg_type === 'image'){
            try {
              const jpegImageSource = this.msg.photo_orig;
              const makeImagePromise = async () => {
                const blob = await CopyImageClipboard.getBlobFromImageSource(jpegImageSource);

                if (CopyImageClipboard.isJpegBlob(blob)) {
                  return CopyImageClipboard.convertBlobToPng(blob);
                }
                else if (CopyImageClipboard.isPngBlob(blob)) {
                  return blob;
                }
              }

              navigator.clipboard.write([new ClipboardItem({ "image/png": makeImagePromise() })])
                  .then(function () { /*console.log('copied');*/ })
                  .catch(function (error) { console.log(error); });
            } catch(e) {
              console.log(`Error: ${e.message}`)
            }
        }
        this.hideMenu()
        this.$emit('copyCallback',this.msg.msg_type)
      },
      deleteMessage(){
        this.hideMenu()
        this.$emit('delete',this.msg.id)
      },
      reply(){
        this.$store.commit(chatModule.mutations.replies.add, {
          userId: this.userId,
          eventId: this.eventId,
          chatMode: this.chatMode,
          msg: this.msg
        })
        this.hideMenu()
        this.$emit('focus')
        this.$emit('replyCallback',this.msg)
        /*let storageId = this.chatMode === 'user' ?
            'reply-chat-' + this.userId
            :
            'reply-chat-event-' + this.userId + '-' + this.eventId;

        localStorage.setItem(storageId, this.msg.id)*/
      },
      hideMenu(){
        if(this.msg){
          let self = this;
          $('#msg-' + self.msg.id).css('top',0);
          $('#msg-' + self.msg.id).find('.timeline').css('opacity',1);
          /*let showTimeLine = function(){

          }
          document.getElementById('msg-' + msg.id).addEventListener('transitionend', showMenuAndEmoji, false );
        */}
        this.showContextOptions = false;
        this.blurVisible = false;
        this.menuVisible = false;
        this.$emit('hideContextMenu', '')
      }
    },

  watch: {
  },
  data() {
    return {
      top:0,
      leftRight:'',
      menuVisible: false,
      blurVisible: false,
      msg: false,
      showContextOptions: false
    }
  }
}
</script>
